/* eslint-disable */

// import lib from '../hybrid';
// import { WSBeacon } from '@tencent/wsbeacon/dist/beacon-all-debug';
// 上线阶段记得改成：
// import { WSBeacon } from '@tencent/wsbeacon';
import { browser } from '../ws-hybrid';
import { load } from '../ws-util';

const APPKEY = 'JS09TWX738XNF9';
let wsBeacon = null;
let pageEntryTime = 0;
let beaconPlayStart = 0;
let beaconPlayTime = 0;
let currentFeed = null;
let lastLocation = 0;
let beacon = null;

const wsBeaconSdk = '//isee.weishi.qq.com/iseecdn/static/js/beacon-all.js';
const wsBeaconDebugSdk = '//isee.weishi.qq.com/iseecdn/static/js/beacon-all-debug.js';

function getWSBeacon(isDebugger) {
  // return new Promise((res1) => {
  return new Promise((res) => {
    /** using https://git.code.oa.com/weishi-web/beacon-report  */
    // let url = '//qzonestyle.gtimg.cn/qzone/hybrid/app/weishi/lib/ws-beacon/dist/beacon-all.js';
    // isDebugger = isDebugger || !!lib.util.getUrlParam('beacon_debugger');
    // if (isDebugger) {
    //   url = '//qzonestyle.gtimg.cn/qzone/hybrid/app/weishi/lib/ws-beacon/dist/beacon-all-debug.js';
    // }

    // seajs.use(url, _ => res(window.WSBeacon || {}));
    if (window.WSBeacon) {
      res(window.WSBeacon || {});
    } else {
      load.loadJs(isDebugger ? wsBeaconDebugSdk : wsBeaconSdk, () => {
        res(window.WSBeacon || {});
      });
    }
  });
}

function getCookie(name) {
  const r = new RegExp(`(?:^|;\\s*)${name}=([^;]*)`);
  const m = document.cookie.match(r);

  return m && m[1] || '';
}

function isQQLogin() {
  const iAuthType = getCookie('iAuthType');
  const openid = getCookie('weishiOpenid') || getCookie('openid');
  const openKey = getCookie('sSessionKey');
  const person_id = getCookie('person_id');

  return iAuthType === '1' && openid && openKey && person_id;
}

function isWXLogin() {
  const iAuthType = getCookie('iAuthType');
  const openid = getCookie('w_openid') || getCookie('openid');
  const accessToken = getCookie('sAccessToken') || getCookie('accessToken');
  const refreshToken = getCookie('sRefreshToken') || getCookie('w_RefreshToken');
  const person_id = getCookie('person_id');

  return iAuthType === '3' && openid && (refreshToken || accessToken) && person_id;
}

function isLogin() {
  return isWXLogin() || isQQLogin();
}

/**
 * 登录上报
 * @param {any} [beacon={}]
 */
async function reportCommonLogin(beacon = {}) {
  if (!beacon || !beacon.report || !beacon.setEventTags) {
    return;
  }

  await beacon.setEventTags({
    common_login: {
      'login.pv': {
        event_type: 1,
        login_type: 1,
      },
    },
  });

  beacon.report('login.pv');
}

/**
 * 页面曝光
 *
 * @param {any} wsBeacon
 */
async function reportPV(beacon) {
  if (!beacon || !beacon.report || !beacon.setEventTags) {
    return;
  }

  await beacon.setEventTags({
    page_visit: {
      'pagevisit.pv': {
        event_type: 1,
      },
    },
  });

  beacon.report('pagevisit.pv');
}

/**
 * 离开上报
 *
 */
async function reportLeave() {
  if (!beacon || !beacon.report || !beacon.setEventTags) {
    return;
  }
  await beacon.setEventTags({
    page_visit: {
      'pagevisit.leave': {
        event_type: 2,
      },
    },
  });

  const pageLeaveTime = +new Date();
  const page_live_time = pageEntryTime > 0 ? pageLeaveTime - pageEntryTime : 0;
  beacon.report('pagevisit.leave', { page_live_time });
}

/**
 * 上报播放开始
 * @private
 * @param {Object} option player option
 */
function reportPlayStart(option) {
  if (beaconPlayStart === 0 && beaconPlayTime === 0) {
    beacon.report('play.start', option);
  }

  if (beaconPlayStart === 0) {
    beaconPlayStart = +new Date();
  }
}

/**
 * 上报开始结束
 * @private
 * @param {Object} option player option
 */
function reportPlayEnd(option) {
  beaconPlayTime += beaconPlayStart > 0 ? +new Date() - beaconPlayStart : 0;
  option.last_location = lastLocation * 1000;
  option.duration = beaconPlayTime;
  if (beaconPlayTime) {
    beacon.report('play.end', option);
  }
  beaconPlayStart = 0;
  beaconPlayTime = 0;
}

/**
 * 播放上报
 *
 * @param {any} type
 */
async function reportVideo(type) {
  if (!beacon || !beacon.report || !beacon.setEventTags) {
    return;
  }

  await beacon.setEventTags({
    video_play: {
      'play.start': { event_type: 1 },
      'play.end': { event_type: 2 },
    },
  });

  const feed = currentFeed || {};
  const video_id = feed.id || '';
  const owner_id = feed.poster_id || '';
  const video_length = feed.video && feed.video.duration || 0;
  const option = {
    video_id,
    owner_id,
    video_length,
  };

  if (type === 1) {
    reportPlayStart(option);
  }

  if (type === 2) {
    reportPlayEnd(option);
  }
}

/**
 * 绑定页面离开事件
 *
 * @param {any} params
 */
function bindPageLeaveEvent() {
  pageEntryTime = +new Date();

  if ((browser.client === 'qq'
  || browser.client === 'qzone')
  && window.mqq && window.mqq.ui
  && window.mqq.ui.setOnCloseHandler) {
    window.mqq.ui.setOnCloseHandler(async () => {
      await reportLeave();
      await reportVideo(2);
      // 解决qq webview多页面调用beacon.init方法时 无法正常关闭页面的问题，原因暂未知
      window.mqq.ui.closeWebViews();
    });
  } else {
    const _unload = window.onunload || function () {
      console.log('leave page.');
    };

    window.onunload = async function () {
      _unload();
      await reportLeave();
      await reportVideo(2);
    };
  }
}

function getCurLocation(e) {
  return e && e.target && e.target.currentTime || 0;
}

function getError(e) {
  return e && e.target && e.target.error || {
    code: -1,
    message: 'unknown error',
  };
}

/**
 * 绑定播放事件
 * @param {any} params
 * params.videoIns          播放器实例
 * params.feed              feed
 * params.cancelEndReport   是否取消播放结束自动上报
 */
async function bindVideoPlayEvent(params) {
  if (!params || !params.videoIns) {
    return;
  }
  const { videoIns } = params;
  let playerError = null;
  // 每次初始化时尝试上报历史数据
  await reportVideo(2);

  // 初始化数据
  lastLocation = 0;
  currentFeed = params.feed;

  videoIns.on('play', async () => {
    await reportVideo(1);
    return;
  });

  videoIns.on('timeupdate', (e) => {
    if (playerError) {
      return;
    }
    lastLocation = getCurLocation(e);
  });

  videoIns.on('ended', async () => {
    if (playerError) {
      return;
    }

    if (!params.cancelEndReport) {
      await reportVideo(2);
      return;
    }
  });

  videoIns.on('pause', () => {
    beaconPlayTime += beaconPlayStart > 0 ? +new Date() - beaconPlayStart : 0;
    beaconPlayStart = 0;
  });

  videoIns.on('error', (e) => {
    playerError = getError(e);
  });
}

/**
 * 根据时间戳生成UUID
 * @export  generateUUID
 * @returns String  返回一个UUID
 */
function generateUUID() {
  const d = new Date();
  const k = d.getTime();
  const str = k.toString(16).slice(1);
  const UUID = 'xxxx-xxxx-4xxx-yxxx-xzx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 3 | 8);

    return v.toString(16);
  });

  const newString = UUID.replace(/[z]/, str);

  return newString;
}


/**
 * 监听页面可见状态
 * @param Function callback  回调函数
 */
function listenDocumentVisible(callback) {
  let visibilityChange = 'visibilitychange';
  if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    visibilityChange = 'webkitvisibilitychange';
  }
  document.addEventListener(visibilityChange, callback);
}

// 定义页面停留时长上报全局参数
const PAGE_TIME_MONITOR = {
  timer: null, // 定时器句柄
  pageSessionId: generateUUID(), // page session id
  startTime: Date.now(), // 页面初始化时的时间
};

// 开启定时器
const startTimer = ({
  durationTime,
  pageSessionId,
  startTime,
  pageTimeExtra,
}) => {
  if (!PAGE_TIME_MONITOR.timer) {
    PAGE_TIME_MONITOR.timer = setInterval(() => {
      beacon.report('page.time', {
        duration: durationTime,
        page_session_id: pageSessionId,
        start_time: startTime,
        live_time: Date.now(),
        page_time_extra: pageTimeExtra,
      });
    }, durationTime * 1000);
  }
};
// 清除定时器
const clearTimer = () => {
  if (PAGE_TIME_MONITOR.timer) {
    clearInterval(PAGE_TIME_MONITOR.timer);
    PAGE_TIME_MONITOR.timer = null;
  }
};
/**
 * 页面停留时间上报
 * @param Object reportParams  上报数据
 * @returns reportPageTime(reportParams)
 */
async function reportPageTimeMonitor(reportParams = {}) {
  if (!beacon || !beacon.report || !beacon.setEventTags) {
    return;
  }
  console.log('PAGE_TIME_MONITOR: ', PAGE_TIME_MONITOR, reportParams);

  let { pageSessionId, startTime } = PAGE_TIME_MONITOR;
  // 心跳上报间隔，单位: 秒，默认值: 2
  let durationTime = 2;
  // 额外上报的参数
  let pageTimeExtra = '';

  if (reportParams) {
    const {
      duration, page_session_id, start_time, page_time_extra,
    } = reportParams;

    if (duration) {
      durationTime = Number(duration) || durationTime;
    }
    if (page_session_id) {
      pageSessionId = page_session_id;
    }
    if (start_time) {
      startTime = start_time;
    }
    if (page_time_extra) {
      if (typeof page_time_extra === 'string') {
        pageTimeExtra = page_time_extra;
      } else {
        pageTimeExtra = JSON.stringify(page_time_extra);
      }
    }
  }

  // 定义page_time_monitor事件
  await beacon.setEventTags({
    page_time_monitor: {
      'page.time': {
        duration: durationTime,
        page_session_id: pageSessionId,
        start_time: startTime,
        live_time: '',
        page_time_extra: pageTimeExtra,
      },
    },
  });

  // 初始化的时候清除定时器, 方便同一页面不同模块传参
  clearTimer();

  // 设置定时器
  startTimer({
    durationTime,
    pageSessionId,
    startTime,
    pageTimeExtra,
  });
  // 页面可见状态变化的时候切换上报状态
  listenDocumentVisible(() => {
    if (document.visibilityState === 'visible') {
      // 显示状态
      startTimer({
        durationTime,
        pageSessionId,
        startTime,
        pageTimeExtra,
      });
    } else if (document.visibilityState === 'hidden') {
      // 隐藏状态
      clearTimer();
    }
  });
}

/**
 * @description 合并commontype和type字段，commontype可以在init beacon的时候进行设置，和pageID等字段同级，代表需要上报的公共的type值。
 * 在后面report或者settag的时候，会对type字段进行合并。
 * @author Morisun
 * @date 2020-12-10
 * @param {*} commonType
 * @param {*} paramObj
 */
function concatType(commonType, paramObj, scene) {
  if (!commonType || !paramObj) return paramObj;

  if (Object.prototype.toString.call(paramObj) !== '[object Object]') return paramObj;

  if (scene === 'report') {
      // 代表目前调用的是report
      paramObj['type'] = getNewType(commonType, paramObj['type']);
      return paramObj;
  } else {
      // 否则，代表是setEventTags
      for (let prop in paramObj) {
          // user_action这一层
          if (typeof paramObj[prop] === 'object') {
              for (let propChild in paramObj[prop]) {
                  // 具体事件名这一层
                  // 重新赋值type字段
                  paramObj[prop][propChild]['type'] = getNewType(commonType, paramObj[prop][propChild]['type'])
              }
          }
      }
      return paramObj;
  }
}

/**
* @description 合并commonType和report或setEventTags中的type
* @author Morisun
* @date 2020-12-10
* @param {*} commonTypeVal
* @param {*} typeVal
* @returns
*/
function getNewType(commonTypeVal, typeVal) {
  // 如果要设置的type为空字符创，则直接返回commonType
  if (!typeVal) return commonTypeVal;

  // commonType转成对象
  const commonTypeObj = typeof commonTypeVal !== 'object' ? JSON.parse(commonTypeVal) : commonTypeVal;
  const isTypeObject = typeof typeVal === 'object';

  // 定义默认的type值
  let type = {};
  try {
      // 防止typeVal为非对象字符串，这里放在trycatch内
      type = isTypeObject ? typeVal : JSON.parse(typeVal);
  } catch (error) {
      console.error(`ws-report beacon concatType error:${error}`);
  }

  // 合并commontype和type字段
  const newType = { ...commonTypeObj, ...type };
  
  // 重新赋值type字段
  return isTypeObject ? newType : JSON.stringify(newType);
}

beacon = {
  config: null,
  wsBeacon: null,
  isInit: false,
  isLoginReport: false,
  pWSBeacon: null,
  // 公共的type，会和上报的type进行合并，重复字段以上报时的字段值为准
  commonType: null,
  async getWSBeacon() {
    if (!this.pWSBeacon) {
      this.pWSBeacon = await getWSBeacon(this.config && this.config.isDebugger);
    }

    return this.pWSBeacon;
  },
  async init(config) {
    console.log('wsBeacon init');
    this.config = config;
    if (this.config && !this.config.appKey) {
      this.config.appKey = APPKEY;
    }

    // 如果有commonType，则暂时存储该公共type，当后面report或者setEventTags时对commonType和type字段进行合并
    if(config.commonType){
      this.commonType = config.commonType;
    }
    wsBeacon = this.wsBeacon = await this.getWSBeacon();
    this.wsBeacon.init && this.wsBeacon.init(this.config);
    this.isInit = true;

    // 是否进行登录上报，默认上报
    const isReportCommmonLogin = config.reportCommonLogin || typeof config.reportCommonLogin === 'undefined'
    console.log('config.reportCommonLogin:', config.reportCommonLogin, isReportCommmonLogin)

    if (!this.isLoginReport && isLogin() && isReportCommmonLogin) {
      this.isLoginReport = true;
      reportCommonLogin(beacon);
    }

    // 是否上报pvuv数据，默认上报；false则不上报
    console.log('config.reportPv:', config.reportPv, config.reportPv || typeof config.reportPv === 'undefined')
    if(config.reportPv || typeof config.reportPv === 'undefined'){
      await reportPV(beacon);
    }
    /**
     * 问题: 离开页面会执行上报处理，在手Q里还会执行关闭相邻的webview操作，使得页面无法返回上一级
     * 解决: 增加一个配置，业务方传入notLeaveEvent为true时，离开页面不做任何操作，则不会关闭相邻的webview，可以正常返回上一级
     * 兼容: 不传notLeaveEvent时，正常执行离开页面上报，兼容旧的逻辑
     */
    if (!config.notLeaveEvent) {
      console.log('*** run leave event ***');
      bindPageLeaveEvent();
    }
  },
  async report(tagName, opt) {
    this.wsBeacon = await this.getWSBeacon();
    if (this.wsBeacon.report) {
       // 如果commontype存在则合并到param中的type字段，如果不存在则直接用param
       const newParam = (this.commonType && opt) ? concatType(this.commonType, opt, 'report') : opt;
      this.wsBeacon.report(tagName, newParam);
    }
  },
  async rawReport(eventName, opt) {
    this.wsBeacon = await this.getWSBeacon();
    if (this.wsBeacon.report) {
      this.wsBeacon.report(eventName, opt);
    }
  },
  async setEventTags(param, opt) {
    this.wsBeacon = await this.getWSBeacon();
    if (this.wsBeacon.setEventTags) {
      // 如果commontype存在则合并到param中的type字段，如果不存在则直接用param
      const newParam = (this.commonType && param) ? concatType(this.commonType, param) : param;
      this.wsBeacon.setEventTags(newParam, opt);
    }
  },
  async setCommonParams(param, opt) {
    this.wsBeacon = await this.getWSBeacon();
    if (this.wsBeacon.setCommonParams) {
      this.wsBeacon.setCommonParams(param, opt);
    }
  },
  bindVideoPlayEvent,
  reportPageTimeMonitor,
};

export default beacon;
